import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, nextTick, ref } from "vue";
import { useSdkStore } from "@/stores/sdk";
import { initSdk } from "@/sdk/init";
// @ts-ignore
import PluginPanel from '@/components/plugin/plugin.vue'
// @ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'
import { useRouter, useRoute } from "vue-router";
import { initDesign } from '@/common/initDesign'
import { initGlobalConfig } from '@/common/initGlobalConfig'
import { initClient } from '@/common/inituser'
import { useUserStore } from '@/stores/user'
import { createDesign } from '@/api/affairs'

export default /*@__PURE__*/_defineComponent({
  __name: 'design',
  setup(__props) {

const router = useRouter();
const route = useRoute()
const sdkStore = useSdkStore();
const userStore = useUserStore()
const islogin = userStore.isLoggedIn
const loadsdk = ref(false)
//@ts-ignore
onMounted(async () => {
  if (route.query.type) {
    localStorage.setItem('pageType', route.query.type as string)
  } else {
    localStorage.removeItem('pageType')
  }
  if (islogin) {
    if (!route.query.id) {
      let pk = localStorage.getItem('pk')
      if (pk) {
        router.replace({
          path: '/editor',
          query: {
            id: pk,
            mode: "user"
          }
        })
      } else {
        const res = await createDesign({
          height: 1000,
          template_id: 0,
          name: '未命名模板',
          width: 1000,
        })
        const params = {
          id: String(res.data?.data?.pk ?? ''),
          mode: 'user',
        }
        localStorage.setItem('pk', String(res.data?.data?.pk ?? ''))
        router.replace({
          path: '/editor',
          query: params
        })
      }
    } else {
      localStorage.setItem('pk', route.query.id as string)
    }
    // localStorage.setItem('token', route.query?.token as string)
  } else {


  }


  loadsdk.value = true
  let title = localStorage.getItem('admin-api-user_name')
  if (title) {
    document.title = title
  } else {
    document.title = '设计引擎'
  }
  await nextTick();
  await initGlobalConfig()
  await initClient()

  // setTimeout(async () => {
  const desginsdk = await initSdk("#page", islogin);
  sdkStore.setSdk(desginsdk);

  loadsdk.value = false
  // }, 500);


  initDesign()
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "page" }, null, -1)),
    (loadsdk.value)
      ? (_openBlock(), _createBlock(NewLoading, {
          key: 0,
          fullscreen: ""
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})